
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'
export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.paddingTop = this.getBreakpointValue(this.blok.paddingTop)
      styles.paddingBottom = this.getBreakpointValue(this.blok.paddingBottom)
      styles.paddingLeft = this.getBreakpointValue(this.blok.paddingLeft)
      styles.paddingRight = this.getBreakpointValue(this.blok.paddingRight)

      return styles
    },
  },
  methods: {
    handleScroll(scrollTarget) {
      if (scrollTarget) {
        this.$gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: scrollTarget,
            offsetY: 70,
          },
        })
      }
    },
  },
}
